import React from 'react';
import { Spin, Select, Checkbox, Modal, Button, message, Radio, Input } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import AttendanceCalendar from '../share/AttendanceCalendar';

const Option = Select.Option;
const RadioGroup = Radio.Group;
const { TextArea } = Input;

export default class AttendanceDetailPage extends React.Component {
  constructor(props) {
    super(props);

    let semester = this.props.location.query.semester?this.props.location.query.semester:SharedTools.getCurrentSemester(), currentRole = CurrentRoleStore.getCurrentRole();
    let semesters = SharedTools.getAllSemesters(SharedTools.getCurrentSemester(), 20171);

    let url = window.location.href;
    let editAttendance = url.indexOf('attendance-detail') > 1 ? false : true;
    let isTeacherAttendance = url.indexOf('teacher-attendance') > 1 ? true : false;

    this.state = {
      semester,
      currentRole,
      semesters,
      schoolId: props.params.schoolId ? props.params.schoolId : currentRole.associatObj.schoolId,
      setAttendance: false,
      editAttendance,
      isTeacherAttendance,
      person: {},
      checkedValues: [],
      isAbsence: true,
      days: [],
      loading: false,
      startDate: null,
      endDate: null,
      calendar_semesters:{},
      reasonComment : 'no_comment',

      reasons: [],
    }

    this.callbackDay = this.callbackDay.bind(this);
    this.teacherAttendance = this.teacherAttendance.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.onChangeReasonCheckbox = this.onChangeReasonCheckbox.bind(this);
    this.goSetCalendarPage = this.goSetCalendarPage.bind(this);

  }

  componentWillReceiveProps(newProps) {
    this.setState({
      semester: newProps.location.query.semester?newProps.location.query.semester:SharedTools.getCurrentSemester(),
    })
  }

  componentDidMount() {
    this.getPersonDetail()
    this.getSchoolInfo()
    this.getSchoolAbsenceReasons()
  }

  getSchoolInfo() {
    DataService.getSchoolInfo(this.state.schoolId).then((res) => {
      let calendar_semester = res.calendar_semester[this.state.semester];
      if (calendar_semester) {
        this.setState({
          startDate: calendar_semester.start_year + '-' + calendar_semester.start_month.toString().padStart(2, '0') + '-' + calendar_semester.start_day.toString().padStart(2, '0'),
          endDate: calendar_semester.end_year + '-' + calendar_semester.end_month.toString().padStart(2, '0') + '-' + calendar_semester.end_day.toString().padStart(2, '0')
        })
      } else {
        this.setState({
          startDate: null,
          endDate: null
        })
      }
      this.setState({
        calendar_semesters:res.calendar_semester
      })

    }).catch((error) => {
      console.log(error)
      this.setState({
        loading: false
      })
      message.error('获取日历失败，请重试！')
    });
  }

  getPersonDetail() {
    this.setState({
      loading: true
    })
    if (this.state.isTeacherAttendance) {
      DataService.getOneTeacherInfo(this.state.editAttendance ? this.props.params.teacherId : this.state.currentRole.roleId ).then((res) => {
        this.setState({
          person: res
        },() => {
          this.getRecordDetail(this.state.semester)  
        })
      }).catch((error) => {
        console.log(error)
      });
    } else {
      DataService.getOneStudentInfo(this.props.params.studentId).then((res) => {
        this.setState({
          person: res
        },() => {
          this.getRecordDetail(this.state.semester)
        })
      }).catch((error) => {
        console.log(error)
      });
    }
  }

  getSchoolAbsenceReasons() {
    DataService.getSchoolAbsenceReasons(this.state.schoolId).then(res => {
      let reasons = res.filter((item) => !item.need_supplement);
      let needSupplement = res.find((item) => item.need_supplement);
      this.setState({
        reasons,
        needSupplement
      })
    })
  }
  
  getRecordDetail(semester) {
    let { isTeacherAttendance, editAttendance, currentRole, schoolId, person, calendar_semesters } = this.state;
    let data = {
      semester: semester,
      school_id: schoolId
    }
    if (isTeacherAttendance) {
      data.teacher_id = editAttendance ? this.props.params.teacherId : currentRole.roleId;
    } else {
      data.student_id = this.props.params.studentId;
      data.grade_id = person.class_record.class_grade_id
    }
    let calendar_semester = calendar_semesters[semester]
    if (calendar_semester) {
      this.setState({
        startDate: calendar_semester.start_year + '-' + calendar_semester.start_month.toString().padStart(2, '0') + '-' + calendar_semester.start_day.toString().padStart(2, '0'),
        endDate: calendar_semester.end_year + '-' + calendar_semester.end_month.toString().padStart(2, '0') + '-' + calendar_semester.end_day.toString().padStart(2, '0')
      })
    } else {
      this.setState({
        startDate: null,
        endDate: null
      })
    }
    this.getSemesterRecord(data)
  }

  getSemesterRecord(data) {
    this.setState({
      loading: true
    })
    
    DataService.getCalendars(data).then((result) => {
      let arrLength = result.length;
      DataService.getSemesterRecord(data).then((res) => {
        for (let index = 0; index < arrLength; index++) {
          let record = res.find((record) => record.year == result[index].year && record.month == result[index].month && record.day == result[index].day);
          if (record) {
            result[index].in_date = record.in_date;
            result[index].is_absence = record.is_absence;
            result[index].is_late = record.is_late;
            result[index].is_leave_early = record.is_leave_early;
            result[index].is_supplement = record.is_supplement;
            result[index].leave_halfway_info = record.leave_halfway_info;
            result[index].absence_reason = record.absence_reason;
            result[index].absence_comment = record.absence_comment;

            // 当天有记录(补卡 || 机器打卡)
            result[index].is_record = true
          }
        }
        this.setState({
          days: result,
          loading: false
        })
      }).catch((error) => {
        console.log(error)
        this.setState({
          loading: false
        })
        message.error('学生考勤详情获取失败！')
      });
    }).catch((error) => {
      console.log(error)
      this.setState({
        loading: false
      })
      message.error('获取日历失败，请重试！')
    });
  }
  
  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      })
      this.getRecordDetail(value)
    }
  }

  callbackDay(year, month, day) {
    let { days, reasons, needSupplement } = this.state;
    let item = days.find((item) => item.year == year && item.month == month && item.day == day);
    let checkedValues = [], reasonValues, reasonComment;
    if (!item.is_absence && typeof(item.is_absence) == "boolean") {
      if (item.is_leave_early) {
        checkedValues.push("3")
      }
      if (item.is_late) {
        checkedValues.push("2")
      }
      if (!item.is_leave_early && !item.is_late) {
        checkedValues.push("1")
        reasonValues = 'sign';
      }
    } else {
      if (reasons.length > 0 || needSupplement) {
        if (item.absence_reason) {
          reasonValues = item.absence_reason.id;
          reasonComment = item.absence_comment;
        }
      } else {
        reasonValues = 'absence'
      }
    }
    if(item.absence_comment)
      reasonComment = item.absence_comment
    else
      reasonComment = 'no_comment'
    this.setState({
      visible: true,
      year,
      month,
      day,
      isAbsence: item.is_absence,
      reasonValues,
      reasonComment,
      checkedValues
    })
  }

  handleCancel() {
    this.setState({
      visible: false,
      checkedValues: [],
      isAbsence: true
    })
  }

  onChangeCheckbox(newValues) {
    let {isAbsence,checkedValues} = this.state
    if(!isAbsence){
      let oldValues = checkedValues;
      let index = newValues.findIndex((item) => item == '2' || item == '3');
  
      if (oldValues.includes('1') && index >= 0) {
        newValues.splice(newValues.indexOf('1'), 1);
      } else if (!oldValues.includes('1') && newValues.includes('1')) {
        newValues = ['1'];
      }
      this.setState({
        checkedValues: newValues
      })
    }

  }

  onChangeReasonCheckbox(e) {
    this.setState({
      reasonValues: e.target.value
    })
  }

  onChangeComment(e) {
    this.setState({
      reasonComment: e.target.value
    })
  }

  onChangeRadio(e) {
    let isAbsence = e.target.value, checkedValues = this.state.checkedValues;
    checkedValues = []
    this.setState({
      isAbsence,
      checkedValues
    })
  }

  teacherAttendance() {
    if (this.state.loading) return;
    let { currentRole, semester, year, month, day, days, editAttendance, isAbsence, checkedValues,reasonComment } = this.state;
    if (!isAbsence&&checkedValues && checkedValues.length == 0) {
      message.warning('请选择考勤状态!');
      return 
    }
    let data = {
      semester,
      school_id: editAttendance ? this.props.params.schoolId : currentRole.associatObj.schoolId, 
      person_type: 'teacher',
      date: year + SharedTools.formatNumber(month) + SharedTools.formatNumber(day),
      status: isAbsence ?  5 : (checkedValues.length == 1) ? checkedValues[0] : 4,
      person_ids: [editAttendance ? this.props.params.teacherId : currentRole.roleId],
      comment:reasonComment
    }
    DataService.batchUpdateAttendance(data).then((res) => {
      let date = days.find((date) => date.year == year && date.month == month && date.day == day);
      if (date) {
        switch (data.status.toString()) {
          case '1':
            date.is_absence = false
            date.is_late = false
            date.is_leave_early = false
            break;
          case '2':
            date.is_absence = false
            date.is_late = true
            date.is_leave_early = false
            break;
          case '3':
            date.is_absence = false
            date.is_late = false
            date.is_leave_early = true
            break;
          case '4':
            date.is_absence = false
            date.is_late = true
            date.is_leave_early = true
            break;
          case '5':
            date.is_absence = true
            date.is_late = false
            date.is_leave_early = false
            break;
        }
        date.is_record = true;
        if(reasonComment&&reasonComment!='no_comment')
          date.absence_comment = reasonComment
        else if(reasonComment==='no_comment')
          date.absence_comment = null
        this.setState({
          days,
          visible: false,
          checkedValues: [],
          isAbsence: true,
          reasonComment:'no_comment',
        })
      } else {
        this.setState({
          visible: false,
          checkedValues: [],
          isAbsence: true,
          reasonComment:'no_comment',
        })
        this.getRecordDetail(this.state.semester)
      }

    }).catch((error) => {
      console.log(error)
      message.error('学生考勤状态更新失败，请重试！')
    });
  }

  studentReasonAttendance() {
    if (this.state.loading) return;
    let { semester, year, month, day, days, isAbsence, reasonValues, needSupplement, reasonComment } = this.state;
    let data = {
      semester,
      school_id: this.props.params.schoolId,
      person_type: 'student',
      date: year + SharedTools.formatNumber(month) + SharedTools.formatNumber(day),
      status: reasonValues == 'sign' ? 1 : 5,
      person_ids: [this.props.params.studentId]
    }
    if (data.status == 5) {
      data.absence_reason_id = reasonValues;
      if (needSupplement && needSupplement.id == reasonValues) {
        data.absence_comment = reasonComment;
      }
    }
    DataService.batchUpdateAttendance(data).then((res) => {
      this.setState({
        visible: false
      })
      this.getRecordDetail(this.state.semester)
    }).catch((error) => {
      console.log(error)
      message.error('学生考勤状态更新失败，请重试！')
    });
  }

  studentAttendance(status) {
    if (this.state.loading) return;
    let { semester, year, month, day, days} = this.state;
    let data = {
      semester,
      school_id: this.props.params.schoolId,
      person_type: 'student',
      date: year + SharedTools.formatNumber(month) + SharedTools.formatNumber(day),
      status: status == 'absence' ? 5 : 1,
      person_ids: [this.props.params.studentId]
    }
    DataService.batchUpdateAttendance(data).then((res) => {
      let date = days.find((date) => date.year == year && date.month == month && date.day == day);
      if (date) {
        date.is_absence = status == 'absence' ? true : false;
        date.is_record = true;
        this.setState({
          days,
          visible: false,
        })
      } else {
        this.setState({
          visible: false
        })
        this.getRecordDetail(this.state.semester)
      }
      
    }).catch((error) => {
      console.log(error)
      message.error('学生考勤状态更新失败，请重试！')
    });
  }

  goSetCalendarPage() {
    hashHistory.push(`teacher-attendance/schools/${this.state.schoolId}/attendance-calendar`);
  }

  batchUpdateAttendance(data) {
    
  } 

  _editTeacherAttendanceView() {
    return (
      <Modal
        visible={this.state.visible}
        title="考勤状况选择"
        onCancel={this.handleCancel}
        footer={[
          <Button key="submit" type="primary" loading={this.state.loading} onClick={this.teacherAttendance}>
            确定
          </Button>,
        ]}
        wrapClassName="edit-teacher-attendance-modal"
      >
        <RadioGroup onChange={this.onChangeRadio} value={this.state.isAbsence}>
          <Radio value={true}>未到</Radio>
          <Radio value={false}>已到</Radio>
        </RadioGroup>
        <Checkbox.Group style={{ width: '100%' }} onChange={this.onChangeCheckbox} value={this.state.checkedValues} disabled={(typeof (this.state.isAbsence) != 'boolean') || this.state.isAbsence}>
          <Checkbox value="1">正常出勤</Checkbox>
          <Checkbox value="2">迟到</Checkbox>
          <Checkbox value="3">早退</Checkbox>
        </Checkbox.Group>
        
        <label>备注：</label>
        <RadioGroup onChange={this.onChangeComment.bind(this)} value={this.state.reasonComment}>
          <Radio value="病假">病假</Radio>
          <Radio value="事假">事假</Radio>
          <Radio value="调休">调休</Radio>
          <Radio value="no_comment">无备注需求</Radio>
        </RadioGroup>
      </Modal>
    )
  }

  _editStudentAbsenceReason() {
    return (
      <Modal
        visible={this.state.visible}
        title="确认未到原因"
        onCancel={this.handleCancel}
        footer={[
          <Button key="submit" type="primary" loading={this.state.loading} onClick={this.studentReasonAttendance.bind(this)}>
            确定
          </Button>,
        ]}
        wrapClassName="edit-teacher-attendance-modal"
      >
        {(this.state.reasons.length > 0 || this.state.needSupplement) ? <RadioGroup style={{ width: '100%' }} onChange={this.onChangeReasonCheckbox} className="checkbox-group" value={String(this.state.reasonValues)}>
          <Radio className="reason-detail bottom-border" value="sign">已到</Radio>
          {this.state.reasons.map((reason) => <Radio key={reason.id} value={String(reason.id)}>{reason.description}</Radio>)}
          {this.state.needSupplement ? <Radio className="reason-detail top-border" value={String(this.state.needSupplement.id)}>{this.state.needSupplement.description}</Radio> : ''}
        </RadioGroup> : <RadioGroup style={{ width: '100%' }} onChange={this.onChangeReasonCheckbox} className="checkbox-group" value={String(this.state.reasonValues)}>
            <Radio value="absence">未到</Radio>
            <Radio value="sign">已到</Radio>
          </RadioGroup>}

        {(this.state.needSupplement && this.state.needSupplement.id == this.state.reasonValues) ? <TextArea className="reason-textarea" placeholder="请填写其他理由" value={this.state.reasonComment} onChange={this.onChangeComment.bind(this)}></TextArea> : ''}
      </Modal>
    )
  }

  _editStudentAttendanceView() {
    let { person, year, month, day} = this.state;
    return (
      <Modal
        visible={this.state.visible}
        title="考勤修改"
        onCancel={this.handleCancel}
        footer={[
          <span key="cancel" type="primary" onClick={this.studentAttendance.bind(this, 'absence')} className="operation-btn btn-left">
            未到校
          </span>,
          <span key="submit" type="primary" onClick={this.studentAttendance.bind(this, 'clock_on')} className="operation-btn btn-right">
            确认到校
          </span>,
        ]}
        wrapClassName="edit-teacher-attendance-modal"
      >
        <div className="modal-content">{person.full_name}宝贝{year}.{month}.{day}日是否到校？</div>
      </Modal>
    )
  }

  render() {
    const { editAttendance, setAttendance, semester, semesters, isTeacherAttendance, person, days, loading, startDate, endDate } = this.state;

    return (
      <div className="teacher-attendance-detail-page">
        <div className="header-label">
          {person.full_name}考勤情况
          <Select value={String(semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)} className="select-semester">
            {semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
          </Select>
        </div>
        {startDate&&endDate?
        <Spin spinning={loading} style={{width: '520px'}}>
          <AttendanceCalendar semester={semester} startDate={startDate} endDate={endDate} setAttendance={setAttendance} editAttendance={editAttendance} callbackDay={this.callbackDay} days={days}/>
        </Spin>:<div className="without-attendance-calendar-view">
                <div className="view-header">该学期未完成老师考勤校历</div>
                <div className="view-label">查看考勤统计需要先去“老师考勤日历”页面设置本学期需要考勤的天数。</div>
                <Button type="primary" onClick={this.goSetCalendarPage}>去设置 老师考勤校历</Button>
              </div>
        }

        {(editAttendance && isTeacherAttendance) ? this._editTeacherAttendanceView(): ''}
        {(editAttendance && !isTeacherAttendance) ? this._editStudentAbsenceReason() : ''}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/AttendanceDetailPage.jsx